/* eslint-disable no-bitwise */

import { message } from "antd";

// 生成 Antd 的Form表单布局
function getFormLayout(span = 4) {
  const spanCount = 24;
  const wrapperSpan = spanCount - span;
  const formItemLayout = {
    labelCol: {
      xs: { span },
      sm: { span },
    },
    wrapperCol: {
      xs: { span: wrapperSpan },
      sm: { span: wrapperSpan },
    },
  };

  const formButtonLayout = {
    wrapperCol: {
      xs: { span: wrapperSpan, offset: span },
      sm: { span: wrapperSpan, offset: span },
    },
  };

  return [formItemLayout, formButtonLayout];
}

// 获取最近三个月日期的数组,如2020/02，2020/03
function getRecentThreeMonthArr() {
  let curYear = new Date().getFullYear();
  let curMonth = new Date().getMonth();
  let targetArr = [];

  if (curMonth >= 2) {
    for (let item = curMonth; item >= 0; item--) {
      if (targetArr.length === 3) {
        return targetArr;
      } else {
        let month = item > 9 ? item : "0" + (item + 1);

        targetArr.push(`${curYear}/${month}`);
      }
    }
    return targetArr;
  } else {
    for (let item = curMonth; item >= -1; item--) {
      if (item === -1 && targetArr.length < 3) {
        item = 12;
        curYear--;
      } else if (targetArr.length === 3) {
        return targetArr;
      } else {
        let month = item > 9 ? item + 1 : "0" + (item + 1);
        targetArr.push(`${curYear}/${month}`);
      }
    }
  }
}

// 日期格式化
function formatDate(time) {
  let date = new Date(time);
  let year = date.getFullYear(date); //年
  let month = date.getMonth() + 1 > 9 ? date.getMonth() + 1 : "0" + (date.getMonth() + 1); //月
  let day = date.getDate() > 9 ? date.getDate() : "0" + date.getDate(); //日
  let hour = date.getHours() > 9 ? date.getHours() : "0" + date.getHours(); //时
  let minute = date.getMinutes() > 9 ? date.getMinutes() : "0" + date.getMinutes(); //分
  let second = date.getSeconds() > 9 ? date.getSeconds() : "0" + date.getSeconds(); //秒
  return year + "-" + month + "-" + day + " " + hour + ":" + minute + ":" + second;
}

// 最近三个月起始时间点时间参数
function getThreeMonthTime() {
  let date = new Date();
  let year = date.getFullYear(); //年
  let month = date.getMonth() + 1; //月
  let day = date.getDate(); //日
  if (month <= 3) {
    year = date.getFullYear() - 1;
    month = 12 + (date.getMonth() + 1 - -3);
  } else {
    month -= 3;
  }
  let result = year + "-" + month + "-" + day;
  return result;
}

// 最近六个月起始时间点时间参数
function getSixMonthTime() {
  let date = new Date();
  let year = date.getFullYear(); //年
  let month = date.getMonth() + 1; //月
  let day = date.getDate(); //日
  if (month <= 6) {
    year = date.getFullYear() - 1;
    month = 12 - (6 - date.getMonth() - 1);
  } else {
    month -= 6;
  }

  let result = year + "-" + month + "-" + day;

  return result;
}

// 当前时间点时间参数
function getCurTime() {
  let date = new Date();
  let year = date.getFullYear(); //年
  let month = date.getMonth() + 1; //月
  let day = date.getDate(); //日

  // 是否闰年
  if ((year % 4 === 0 && year % 100 !== 0) || year % 400 === 0) {
    if (month === 2 && day === 29) {
      month = 3;
      day = 1;
    } else if (
      ([1, 3, 5, 7, 8, 10, 12].includes(month) && day === 31) ||
      (![1, 3, 5, 7, 8, 10, 12].includes(month) && day === 30)
    ) {
      // 判断是否是其他月份最后一天
      month += 1;
      day = 1;
    } else {
      day += 1;
    }
  } else {
    if (month === 2 && day === 28) {
      month = 3;
      day = 1;
    } else if (
      ([1, 3, 5, 7, 8, 10, 12].includes(month) && day === 31) ||
      (![1, 3, 5, 7, 8, 10, 12].includes(month) && day === 30)
    ) {
      // 判断是否是其他月份最后一天
      month += 1;
      day = 1;
    } else {
      day += 1;
    }
  }

  let result = year + "-" + month + "-" + day;

  return result;
}

// 全局弹窗，功能开发中
function showFeatureAreDevelopingMessage() {
  message.destroy();
  message.info("功能开发中~");
}

// Antd普通表格列渲染
const renderContent = (value, row, index) => {
  return {
    children: value,
    props: {},
  };
};

function getCurMonthStr() {
  let date = new Date();
  let year = date.getFullYear(); //年
  let month = date.getMonth() + 1 < 10 ? "0" + (date.getMonth() + 1) : date.getMonth() + 1; //月

  let result = year + "/" + month;
  return result;
}

function getLastMonthStr() {
  let date = new Date();
  let year = date.getFullYear(); //年
  let tempMonth = date.getMonth() + 1;
  let month;
  if (tempMonth == 1) {
    year -= 1;
    month = 12;
  } else if (tempMonth - 1 < 10) {
    month = "0" + (tempMonth - 1);
  } else {
    month = tempMonth - 1;
  }
  let result = year + "/" + month;
  return result;
}

function getTwoMonthAgoStr() {
  let date = new Date();
  let year = date.getFullYear(); //年
  let tempMonth = date.getMonth() + 1;
  let month;
  if (tempMonth <= 2) {
    year -= 1;
    month = 12 - tempMonth + 1;
  } else if (tempMonth - 2 < 10) {
    month = "0" + (tempMonth - 2);
  } else {
    month = tempMonth - 2;
  }
  let result = year + "/" + month;
  return result;
}

/**
 * 等待
 * @param timeout 毫秒
 */
export function delay(timeout: number) {
  return new Promise<void>((yes) => {
    setTimeout(() => {
      yes();
    }, timeout);
  });
}

export {
  getFormLayout,
  getRecentThreeMonthArr,
  getCurTime,
  formatDate,
  getThreeMonthTime,
  getSixMonthTime,
  showFeatureAreDevelopingMessage,
  renderContent,
  getCurMonthStr,
  getLastMonthStr,
  getTwoMonthAgoStr,
};
